var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgWaterHighestIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 19,
    viewBox: "0 0 13 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.75128 4C7.28873 3.21391 6.85312 2.48999 6.5 1.909C6.14688 2.48999 5.71127 3.21391 5.24872 4H7.75128ZM8.33421 5H4.66579C3.64874 6.76232 2.61332 8.65654 2.1035 9.8915C1.74429 10.7398 1.53989 11.6456 1.5 12.566C1.5 13.8921 2.02678 15.1639 2.96447 16.1015C3.90215 17.0392 5.17392 17.566 6.5 17.566C7.82608 17.566 9.09785 17.0392 10.0355 16.1015C10.9732 15.1639 11.5 13.8921 11.5 12.566C11.4601 11.6456 11.2557 10.7398 10.8965 9.8915C10.3867 8.65654 9.35126 6.76232 8.33421 5ZM1.179 9.5095C2.412 6.529 6.5 0 6.5 0C6.5 0 10.588 6.529 11.821 9.5095C12.2318 10.4784 12.4619 11.5143 12.5 12.566C12.5 14.1573 11.8679 15.6834 10.7426 16.8086C9.61742 17.9339 8.0913 18.566 6.5 18.566C4.9087 18.566 3.38258 17.9339 2.25736 16.8086C1.13214 15.6834 0.5 14.1573 0.5 12.566C0.538075 11.5143 0.768195 10.4784 1.179 9.5095Z",
    fill: "black"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgWaterHighestIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Water_Highest_icon.22292ebb0fb105e369e4159501ee973f.svg";